// extracted by mini-css-extract-plugin
module.exports = {"header":"TemplateList_header_eVu0Y","workflowButton":"TemplateList_workflowButton_CfqA-","button":"TemplateList_button_3Xax3","nodes":"TemplateList_nodes_1tyam"};